import { render, staticRenderFns } from "./BAutocompleteEventPublicationsStorages.vue?vue&type=template&id=3d2e7844&"
import script from "./BAutocompleteEventPublicationsStorages.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteEventPublicationsStorages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports